import * as React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { BaseRouteParams } from 'hocs'
import { Container } from 'uiComponents/settingsContainer'
import SettingsSectionTabs from 'settings/accountSettings/sectionTabs'
import { SETTINGS_TABLE_HEADER_SLOT_ID } from 'settings/accountSettings/tableHeaderSlot'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'
import { NavigationBack } from 'uiComponents/navigation/navigationBack'

interface UsersPageProps {
    children?: React.ReactNode
}

const UsersPageContainer: React.FC<UsersPageProps> = ({ children }) => {
    const { accountSlug } = useParams<BaseRouteParams>()
    const location = useLocation()
    const history = useHistory()
    // Editing one user is a detail page: the band shows the way back to the
    // list rather than the section bar.
    const isUserForm = location.pathname.includes('/users/user_form')

    return (
        <div style={{ position: 'relative' }} id="account-settings">
            {isUserForm ? (
                <InSectionTabsSlot>
                    <div className="detail-page-back">
                        <NavigationBack
                            onClick={() => history.push(`/account/${accountSlug}/settings/users/user_list`)}
                            text="Back to users"
                        />
                    </div>
                </InSectionTabsSlot>
            ) : (
                <SettingsSectionTabs />
            )}
            <div className="settings-table-header" id={SETTINGS_TABLE_HEADER_SLOT_ID} />
            <Container style={{ marginBottom: 0 }}>{children}</Container>
        </div>
    )
}

export default UsersPageContainer
